import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/plans');

const mockPlans = [
  {
    id: 1,
    title: 'Introduction à la programmation Python',
    course: 'INF101',
    status: 'validé',
    submittedAt: '2023-10-26',
    lastUpdated: '2023-10-28',
    commentsCount: 5,
    pdfUrl: '#',
    comments: [
      { label: 'Objectifs du cours', ok: true },
      { label: 'Planification des évaluations', ok: true },
      { label: 'Alignement compétence', ok: false },
    ],
  },
  {
    id: 2,
    title: 'Algorithmes et structures de données',
    course: 'INF201',
    status: 'en révision',
    submittedAt: '2023-11-01',
    lastUpdated: '2023-11-02',
    commentsCount: 2,
    pdfUrl: '#',
    comments: [
      { label: 'Description du cours', ok: true },
      { label: 'Médiagraphie', ok: false },
    ],
  },
  {
    id: 3,
    title: 'Base de données relationnelles',
    course: 'BD301',
    status: 'en attente',
    submittedAt: '2023-11-05',
    lastUpdated: '2023-11-05',
    commentsCount: 0,
    pdfUrl: '#',
    comments: [],
  },
  {
    id: 4,
    title: 'Développement web avancé',
    course: 'WEB401',
    status: 'rejeté',
    submittedAt: '2023-11-10',
    lastUpdated: '2023-11-12',
    commentsCount: 3,
    pdfUrl: '#',
    comments: [
      { label: 'PIEA abrégée', ok: false },
      { label: 'Évaluations sommatives', ok: false },
      { label: 'Calendrier', ok: true },
    ],
  },
  {
    id: 5,
    title: 'Réseaux informatiques fondamentaux',
    course: 'RES202',
    status: 'validé',
    submittedAt: '2023-11-15',
    lastUpdated: '2023-11-15',
    commentsCount: 1,
    pdfUrl: '#',
    comments: [{ label: 'Préalables', ok: true }],
  },
];

const mockChefs = [
  { id: 10, nom: 'Karim El Mansouri' },
  { id: 11, nom: 'Sophie Tremblay' },
  { id: 12, nom: 'Nadia Benali' },
];

export async function fetchTeacherPlans() {
  try {
    const response = await apiFetch(`${API_BASE}`, {
      auth: true,
    });
    if (!response.ok) {
      throw new Error('Erreur lors du chargement des plans');
    }
    return response.json();
  } catch (err) {
    return mockPlans;
  }
}

export async function fetchChefs() {
  try {
    const response = await apiFetch(`${API_BASE}/chefs`, {
      auth: true,
    });
    if (!response.ok) {
      throw new Error('Erreur lors du chargement des chefs');
    }
    return response.json();
  } catch (err) {
    return mockChefs;
  }
}

export async function uploadPlan(formData) {
  try {
    const response = await apiFetch(`${API_BASE}/upload`, {
      method: 'POST',
      auth: true,
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Téléversement impossible');
    }

    return response.json();
  } catch (err) {
    const newPlan = {
      id: Date.now(),
      title: formData.get('plan_title') || 'Nouveau plan',
      course: (formData.get('classe_nom') || '').split(' ')[0] || 'N/A',
      status: 'en attente',
      submittedAt: new Date().toISOString().slice(0, 10),
      lastUpdated: new Date().toISOString().slice(0, 10),
      commentsCount: 0,
      pdfUrl: '#',
      comments: [],
    };
    return { plan: newPlan, mock: true };
  }
}

export function getMockPlans() {
  return mockPlans;
}

export async function getAllPlans() {
  const response = await apiFetch(`${API_BASE}/`, {
    method: 'GET',
    auth: true,
  });

  if (!response.ok) {
    throw new Error('Erreur lors de la récupération des plans');
  }

  return response.json();
}

export async function deletePlan(planId) {
  const response = await apiFetch(`${API_BASE}/${planId}`, {
    method: 'DELETE',
    auth: true,
  });

  if (!response.ok) {
    throw new Error('Erreur lors de la suppression du plan');
  }

  return response.json();
}

export async function updatePlanStatus(planId, newStatus) {
  const response = await apiFetch(`${API_BASE}/${planId}/status`, {
    method: 'PATCH',
    auth: true,
    json: true,
    body: JSON.stringify({ statut: newStatus }),
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Erreur lors de la mise à jour du statut');
  }

  return response.json();
}
